"use client";

import { useRouter } from "next/navigation";

/**
 * Shared close behaviour for an always-open AuthModal gate (MyResultsAuthGate,
 * QuizAuthGate): if there's somewhere to go back to, go there — otherwise the
 * gate was reached directly (a fresh tab, a bookmark) and there's nowhere to
 * return to but the marketing home page.
 *
 * `onClose` is optional and fires before navigation, for a caller that needs
 * to record the dismissal (e.g. a PostHog event) — it must not depend on the
 * navigation itself, since `router.back()` is fire-and-forget.
 */
export function useAuthGateClose(onClose?: () => void): () => void {
  const router = useRouter();

  return function handleClose() {
    onClose?.();
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push("/");
    }
  };
}
